import React from 'react';
import { Form } from 'antd';
import { MinusCircleOutlined } from '@ant-design/icons';
import { FormItem } from '@xbcb/form-item-components';
import { NamePath } from '@xbcb/ui-types';
import { useTheme } from 'styled-components';
import { ItemIdentifierType } from '__generated__/graphql';
import {
  StyledFieldRow,
  StyledAddonSelect,
  StyledInput,
  StyledRemoveButton,
} from './styles';

const IDENTIFIER_TYPE_OPTIONS = [
  { value: ItemIdentifierType.SE, label: 'SN', title: 'Serial Number' },
  { value: ItemIdentifierType.MN, label: 'MN', title: 'Model Number' },
  { value: ItemIdentifierType.RN, label: 'RN', title: 'Registered Number' },
  {
    value: ItemIdentifierType.ALT,
    label: 'ALT',
    title: 'Alternate Identifier',
  },
];

export interface ProductIdentifierFieldsProps {
  localNamePath: NamePath;
  readOnly?: boolean;
  disabled?: boolean;
  onRemove?: () => void;
  showRemove?: boolean;
}

const ProductIdentifierFields: React.FC<ProductIdentifierFieldsProps> = ({
  localNamePath,
  readOnly = false,
  disabled = false,
  onRemove,
  showRemove = true,
}) => {
  const theme = useTheme();

  return (
    <StyledFieldRow>
      <FormItem
        name={[...localNamePath, 'number']}
        $itemSize={theme.size.short_medium}
        $readOnly={readOnly}
      >
        <StyledInput
          addonBefore={
            <Form.Item name={[...localNamePath, 'type']} noStyle>
              <StyledAddonSelect
                options={IDENTIFIER_TYPE_OPTIONS}
                disabled={disabled || readOnly}
                placeholder="Type"
                allowClear
              />
            </Form.Item>
          }
          maxLength={17}
          disabled={disabled || readOnly}
          placeholder="Enter identifier"
        />
      </FormItem>
      {showRemove && !readOnly && (
        <StyledRemoveButton
          type="text"
          danger
          icon={<MinusCircleOutlined />}
          onClick={onRemove}
          disabled={disabled}
        >
          Remove
        </StyledRemoveButton>
      )}
    </StyledFieldRow>
  );
};

export default ProductIdentifierFields;
